import * as React from "react";
import Drawer from "@mui/material/Drawer";
import "./HeaderDrawer.css";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LanguageIcon from "@mui/icons-material/Language";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import { Divider, Avatar, Typography, Chip } from "@mui/material";
import useStore from "../stores/useStore";
import EersteKeerModal from "../modals/EersteKeerModal";

const HeaderDrawer = ({ open, toggleDrawer }) => {
  const { logout, user } = useAuth0();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { languageSaved, setLanguageSaved, userData, checkCount } = useStore();
  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  const handleNavigate = (path) => {
    navigate(path);
    toggleDrawer(false)();
  };

  const getUserInitial = () => {
    if (userData?.name) {
      return userData.name.charAt(0).toUpperCase();
    }
    if (user?.name) {
      return user.name.charAt(0).toUpperCase();
    }
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return "?";
  };

  const getUserDisplayName = () => {
    if (userData?.name) return userData.name;
    if (user?.name) return user.name;
    if (user?.email) return user.email.split('@')[0];
    return "Gebruiker";
  };

  return (
    <Drawer
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: { width: "min(440px, 90%)", background: "#FFF" }, // Pas de breedte van de Drawer aan
      }}
    >
      <div className="drawer-list">


        {/* User Profile Section */}
        <div className="drawer-user-section">
          <Avatar
            sx={{
              width: 56,
              height: 56,
              bgcolor: '#ffffff',
              color: '#439BD9',
              fontSize: '24px',
              fontWeight: 'bold',
              border: '2px solid rgba(255,255,255,0.3)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
          >
            {getUserInitial()}
          </Avatar>
          <div className="user-info">
            <Typography variant="body1" sx={{ 
              fontWeight: 500, 
              color: '#ffffff',
              fontSize: '0.95rem',
              marginBottom: '1px',
              lineHeight: 1.3
            }}>
              {getUserDisplayName()}
            </Typography>
            <Typography variant="body2" sx={{ 
              color: 'rgba(255,255,255,0.75)', 
              fontSize: '0.75rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '180px',
              lineHeight: 1.2,
              marginBottom: '4px'
            }}>
              {user?.email || 'gebruiker@email.com'}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Chip
                label="PREMIUM"
                sx={{
                  backgroundColor: '#10B981',
                  color: '#FFFFFF',
                  fontSize: '10px',
                  fontWeight: 700,
                  height: '20px',
                  width: 'auto',
                  '& .MuiChip-label': {
                    paddingX: '6px',
                  },
                }}
              />
              <Typography variant="caption" sx={{ 
                color: 'rgba(255,255,255,0.6)', 
                fontSize: '9px',
                fontStyle: 'italic'
              }}>
                (tijdelijk gratis)
              </Typography>
            </div>
          </div>
          <CloseIcon
            onClick={toggleDrawer(false)}
            sx={{ 
              cursor: 'pointer', 
              color: '#ffffff',
              fontSize: '28px',
              padding: '4px',
              borderRadius: '50%',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                transform: 'rotate(90deg)'
              }
            }}
          />
        </div>

        <div className="drawer-links">
          {/* Main Navigation Section - Top */}
          <div className="drawer-section">
            <div className="drawer-item"
              onClick={() => {
                handleNavigate("/");
              }}
            >
              <AssignmentIcon className="drawer-icon" />
              <span>{t("myChecks")}</span>
              <div className="counter-badge">{checkCount}</div>
            </div>
            <div className="drawer-item"
              onClick={() => {
                handleNavigate("new-check");
              }}
            >
              <AddCircleOutlineIcon className="drawer-icon" />
              <span>{t("newCheck")}</span>
            </div>
            <div className="drawer-item"
              onClick={() => {
                handleNavigate("voorwaardengids");
              }}
            >
              <MenuBookIcon className="drawer-icon" />
              <span>{t("voorwaardengids")}</span>
            </div>
          </div>

          <div className="drawer-spacer"></div>

          {/* Settings & Account Section - Bottom */}
          <div className="drawer-section">
            <div className="drawer-item language-modal">
              <LanguageIcon className="drawer-icon" />
              <EersteKeerModal
                languageSaved={languageSaved}
                setLanguageSaved={setLanguageSaved}
                headerVariant
                hideFlag={true}
              />
            </div>
            <div className="drawer-item"
              onClick={() => {
                handleNavigate("account-settings");
              }}
            >
              <SettingsIcon className="drawer-icon" />
              <span>{t('Accountinstellingen')}</span>
            </div>
            <div className="drawer-item"
              onClick={() => {
                handleLogout();
              }}
            >
              <LogoutIcon className="drawer-icon" />
              <span>{t("logout")}</span>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default HeaderDrawer;
